<template>
  <div class="zj-demo-player">
    <zj-layout-container>
      <zj-layout-header>
        <h1 style="margin: 0rem 6rem;">视频播放器</h1>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable" ref="container">

          <div>
            <video ref="video1"  width="640" height="400" muted controls></video>
          </div>
          
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import Wfs from '../../../../../player/wfs/wfs.js';
export default {
    name: 'ZjDemoWfsPlayer',
    controller: 'UI',
    action: 'wfsplayer',
    data () {
      return {
      };
    },

    mounted() {
      this.$nextTick(()=>{
        this.wfs = new Wfs({
          appConfig: this.config
        });    
        this.wfs.attachMedia(this.$refs.video1, {
          cameraId: 'ec4720b3fe9448c385ca764e56b42618',
          cameraName: '至圣码头报警柱',
          scaleMode: 1,
          streamType: 1,
          zipMethod: 2
        });
      });

    },
    destroyed() {
      if (this.wfs) {
        this.wfs.destroy();
        this.wfs = null;
      }
    }
}
</script>
